import React from "react";
import {
  MainContainer,
  ScrollableContainer
} from "./CardsScrollableContainer.styles";
import { useSelector } from "react-redux";

const CardsScrollableContainer = ({
  marginTop,
  calcHeight,
  customClassName = "",
  children,
}) => {
  const isHeaderShrink = useSelector((state) => state.header.isHeaderShrink);
  return (
    <MainContainer
      margintop={marginTop}
      calcheight={calcHeight}
      className={customClassName}
      isHeaderShrink={isHeaderShrink}
    >
      <ScrollableContainer>{children}</ScrollableContainer>
    </MainContainer>
  );
};

export default CardsScrollableContainer;
